// eslint-disable-next-line import-x/prefer-default-export
export const columns = [
  {
    name: 'id',
    hidden: true,
  },
  {
    name: 'transferDate',
    label: 'Date',
  },
  {
    name: 'currencyId',
    label: 'Currency',
  },
  {
    name: 'status',
    label: 'Status',
  },
  {
    name: 'sum',
    label: 'Amount',
  },
  {
    name: 'debitAccountId',
    label: 'Debit account No.',
  },
  {
    name: 'creditAccountId',
    label: 'Credit account No.',
  },
];
